import styled from 'styled-components/macro';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

const StyledDrawer = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    background-color: var(--widget);
    box-shadow: var(--widget-shadow);
    padding: 30px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  box-shadow: none !important;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin: 0 !important;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 12px !important;
  min-height: unset !important;
  height: 44px;
  margin: 0 -10px !important;
  border-radius: 10px !important;
  transition: background-color var(--transition);

  .MuiAccordionSummary-content {
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    background: var(--body);
  }

  .icon-chevron-down {
    will-change: transform;
    transition: all var(--transition);
    color: var(--text);
    opacity: 0.4;
    font-size: 0.625rem;
  }

  &.Mui-expanded, &.active {
    background: rgba(253, 202, 64, 0.12);

    .icon-chevron-down {
      transform: rotate(180deg);
      color: var(--highlight);
      opacity: 1;
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 6px 10px 14px 24px !important;
  display: flex;
  flex-direction: column;
  gap: 4px;

  a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text);
    opacity: 0.65;
    transition: all var(--transition);
    width: 100%;
    font-family: var(--heading-font);
    font-weight: 500;
    font-size: 0.75rem;
    padding: 7px 10px;
    border-radius: 8px;

    .icon {
      font-size: 13px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    &:hover, &:focus {
      opacity: 1;
      background: var(--body);
      color: var(--header);
    }

    &.active {
      opacity: 1;
      background: rgba(253, 202, 64, 0.12);
      color: var(--highlight);
      font-weight: 700;
    }
  }
`;

const SingleLink = styled(StyledAccordionSummary)`
  display: flex;
  align-items: center;
  
  &.pinned {
    margin-top: 15px !important;
  }
`;

const Link = styled.span`
  color: var(--text);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: color var(--transition);
  height: fit-content;

  &:hover, &:focus,
  &.active {
    color: var(--header);
  }

  .icon {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 50%;
    background: rgba(253, 202, 64, 0.12);
    color: var(--highlight);
  }
`;

export {StyledDrawer, SingleLink, Link, StyledAccordion, StyledAccordionSummary, StyledAccordionDetails}